import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'

import { IncidentsResultConfig } from '../../configuration'

export const incidentsResultConfig: IncidentsResultConfig<BasketballIncidentId> =
  {
    scoringIncidents: new Map([
      [BasketballIncidentId.FreeThrowIn, { add: 1, visible: true }],
      [BasketballIncidentId.TwoPointShotMade, { add: 2, visible: true }],
      [BasketballIncidentId.ThreePointShotMade, { add: 3, visible: true }],
      [BasketballIncidentId.FourPointShotMade, { add: 4, visible: true }],
    ]),
  }
